import { getAuthCode } from "./getAuthCode";
export const fetchVoices = async (setVoices) => {
    try {
      const response = await fetch(process.env.REACT_APP_BACKEND_URL + "/retrieveVoices", {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body:JSON.stringify({auth_code:await getAuthCode()})
      });
      const result = await response.json();
      setVoices(result.voices);
    } catch (error) {
      console.log(error);
    }
  };